import { Skeleton } from "@mui/material";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getRequisitionPsychometricLanguages } from "../../../store/psychometric/actions";
import ReactPaginate from "react-paginate";
import ListSkeleton from "../../common/components/ListSkeleton";
import {
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemAvatar,
  Avatar,
} from "@mui/material";

const RequisitionPsychometricLanguages = (props) => {
  const {
    requisitionId,
    requisitionPsychometricLanguages,
    getRequisitionPsychometricLanguages,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  useEffect(
    () => {
      getRequisitionPsychometricLanguages(requisitionId, setIsLoading);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [requisitionId]
  );

  const getNo = (idToSearch) =>
    requisitionPsychometricLanguages.findIndex(({ id }) => id === idToSearch);
  return (
    <>
      {!isLoading && !!requisitionPsychometricLanguages.length && (
        <div className="col-lg-12 mt-3">
          <strong>Psychometric Languages</strong>

          <List
            className="mt-2"
            sx={{
              borderRadius: "8px",
              border: `1px solid #c8c6c6`,
              backgroundColor: "#f9f9f9",
            }}
            dense
          >
            {requisitionPsychometricLanguages.map((row, index) => (
              <React.Fragment key={row.id}>
                <ListItem dense>
                  <ListItemAvatar>
                    <Avatar
                      style={{
                        fontSize: "16px",
                        border: "1px solid #c8c6c6",
                      }}
                      className="bg-white text-dark "
                    >
                      {getNo(row.id) + 1}
                    </Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <span className={`${"font-weight-light"}`}>
                        {row.language?.name}
                      </span>
                    }
                  />
                </ListItem>

                {requisitionPsychometricLanguages.length > index + 1 && (
                  <Divider />
                )}
              </React.Fragment>
            ))}
          </List>
        </div>
      )}

      {isLoading && (
        <div className="col-lg-12 mt-3">
          <ListSkeleton />
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ loading, requisitionPsychometricLanguages }) => {
  return {
    loading,
    requisitionPsychometricLanguages,
  };
};
export default connect(mapStateToProps, {
  getRequisitionPsychometricLanguages,
})(RequisitionPsychometricLanguages);
